/**
 * AnalysisHomePage
 * Main landing page for Falcon Analysis app
 */

import React from "react";

import { ExperimentOutlined } from "@ant-design/icons";
import { Typography, Space } from "antd";

const { Title, Text } = Typography;

export const AnalysisHomePage: React.FC = () => {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{ padding: "32px", width: "100%" }}
    >
      <Text
        style={{
          fontFamily: "IBM Plex Mono, monospace",
          fontSize: "12px",
          fontWeight: 500,
          textTransform: "uppercase",
          letterSpacing: "0.1em",
          color: "#BB8800",
          display: "block",
        }}
      >
        FALCON ANALYSIS
      </Text>

      <Space direction="vertical" size="small">
        <Title
          level={2}
          style={{
            color: "#e0e0e0",
            fontFamily: "Syne, sans-serif",
            marginBottom: 0,
          }}
        >
          <ExperimentOutlined
            style={{ marginRight: "12px", color: "#BB8800" }}
          />
          Analysis Dashboard
        </Title>

        <Text style={{ color: "#999", fontSize: "16px" }}>
          Data-driven analysis and insights engine
        </Text>
      </Space>
    </Space>
  );
};

export default AnalysisHomePage;
